import React from 'react';

// Components
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';

// Styles
import './MobileOnboardingWrapper.scss';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const MobileOnboardingWrapper = ({ children, className }: Props) => {
  const baseClassName = 'MobileOnboardingWrapper';

  return (
    <WpPageLayout className={baseClassName}>
      <WpPageBody>
        <div className={`${baseClassName}__body`}>
          <div className={`${baseClassName}__body__main ${className ? className : ''}`}>{children}</div>
          <div className={`${baseClassName}__body__footer`}>
            <WpIllustration
              src={Illustrations.pi_logo_full_red_with_text}
              className={`${baseClassName}__body__footer__logo`}
              alt="Predictive Index logo"
            />
          </div>
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default MobileOnboardingWrapper;
